import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  eyebrow: {
    id: 'catalog.home.courses-list.eyebrow',
    defaultMessage: 'Catalog',
    description: 'Eyebrow label above the home courses section title.',
  },
  title: {
    id: 'catalog.home.courses-list.title',
    defaultMessage: 'Discover our courses',
    description: 'Title of the home courses section.',
  },
  errorMessage: {
    id: 'catalog.home.courses-list.error-message',
    defaultMessage: 'If the problem persists, contact {supportEmail}.',
    description: 'Error page message for the home courses section.',
  },
  errorTitle: {
    id: 'catalog.home.courses-list.error-title',
    defaultMessage: 'Unable to load catalog',
    description: 'Error title for the home courses section.',
  },
  noCoursesAvailable: {
    id: 'catalog.home.courses-list.no-courses-available',
    defaultMessage: 'No courses available',
    description: 'No courses available alert title for the home courses section.',
  },
  noCoursesAvailableMessage: {
    id: 'catalog.home.courses-list.no-courses-available-message',
    defaultMessage: 'The catalog will be filled soon. Come back a little later to discover new training.',
    description: 'No courses available alert message for the home courses section.',
  },
  viewAllCoursesButton: {
    id: 'category.catalog.home-page.view-courses-button',
    defaultMessage: 'View full catalog',
    description: 'Label for the button that redirects to the courses page.',
  },
});

export default messages;
